<template>
  <div class="search-box">
    <!--搜索项-->
    <el-select
      class="search-key-select"
      v-model="searchKey"
      @change="clearSearchValue"
      placeholder="请选择"
    >
      <el-option
        v-for="option in searchKeyOptions"
        :key="option.value"
        :label="option.label"
        :value="option.value"
      ></el-option>
    </el-select>
    <!--搜索值:下拉框-->
    <el-select
      class="search-value-select"
      v-if="options"
      v-model="searchValue"
      clearable
      filterable
      @change="search"
      placeholder="请选择"
    >
      <el-option
        v-for="option in options"
        :key="option.value"
        :label="option.label"
        :value="option.value"
      ></el-option>
    </el-select>
    <!--人员选择-->
    <user-selector
      v-else-if="searchKey === 'assignee'"
      v-model="searchValue"
      :project-id="projectId"
      multiple
      @input="search"
    ></user-selector>
    <!--    角色选择-->
    <el-select
      v-else-if="searchKey === 'assigneeRole'"
      v-model="searchValue"
      filterable
      clearable
      placeholder="请选择角色"
    >
      <el-option
        v-for="item in roles"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      ></el-option>
    </el-select>
    <!--    时间/数字间隔选择-->
    <special-compare-value
      v-else-if="['completeAt', 'startAt', 'dueDate', 'timeoutDay'].includes(searchKey)"
      class="special-value"
      ref="specialCompare"
      :control="curControl"
      @input="search"
    ></special-compare-value>
    <!--普通字段-->
    <el-input
      v-else
      v-model="searchValue"
      size="small"
      placeholder="请输入搜索内容"
      spellcheck="false"
      clearable
      @keyup.enter.native.stop="search"
      @clear="search"
      class="search-input"
    ></el-input>
    <div class="icon-search-box" @click="search">
      <i class="el-icon-search"></i>
    </div>
  </div>
</template>

<script>
import UserSelector from "@/components/FormControl/UserSelector"
import SpecialCompareValue from "@/components/Sheet/QuickSearch/SpecialCompareValue"
import * as ProjectApi from "@/api/project/project"
import _ from "lodash"

export default {
  name: "search-box",
  props: {
    projectId: String,
    from: String
  },
  components: {
    SpecialCompareValue,
    UserSelector
  },
  data() {
    return {
      searchKey: "name",
      searchValue: null,
      roles: [],
      searchKeyOptions: [
        { label: "任务标题", value: "name" },
        { label: "状态", value: "status" },
        { label: "优先级", value: "priority" },
        { label: "备注", value: "description" },
        { label: "负责人", value: "assignee" },
        { label: "负责角色", value: "assigneeRole" },
        { label: "开始时间", value: "startAt", _type: "time", timeType: "年月日时分秒" },
        { label: "截止时间", value: "dueDate", _type: "time", timeType: "年月日时分秒" },
        { label: "完成时间", value: "completeAt", _type: "time", timeType: "年月日时分秒" },
        { label: "逾期天数", value: "timeoutDay" }
      ]
    }
  },
  computed: {
    curControl() {
      return this.searchKeyOptions.find(control => control.value === this.searchKey) || {}
    },
    searchOptionMap() {
      return {
        status: [
          { label: "待处理", value: "待处理" },
          { label: "待审核", value: "待审核" },
          { label: "已完成", value: "已完成" }
        ],
        priority: [
          { label: "低", value: 0 },
          { label: "中", value: 1 },
          { label: "高", value: 2 },
          { label: "紧急", value: 3 }
        ]
      }
    },
    options() {
      return this.searchOptionMap[this.searchKey]
    }
  },
  created() {
    if (this.from !== "todoList")
      ProjectApi.getAllProjectRole(this.projectId).then(roles => (this.roles = roles))
  },
  methods: {
    search() {
      this.$nextTick(() => {
        if (!this.searchKey) return this.$message.warning("请先选择要搜索的字段！")
        if (["completeAt", "startAt", "dueDate", "timeoutDay"].includes(this.searchKey)) {
          // 获取时间/逾期天数间隔
          let numberRange = _.cloneDeep(this.$refs.specialCompare.numberRange)
          let timeRange = _.cloneDeep(this.$refs.specialCompare.timeRange)
          if (this.searchKey === "timeoutDay") this.searchValue = numberRange
          else this.searchValue = timeRange
        }
        if (
          (this.searchValue?.length > 0 && this.searchValue[0] === undefined) ||
          this.searchValue?.length === 0
        )
          this.searchValue = null
        this.$emit("search", this.searchKey, this.searchValue)
      })
    },
    clearSearchValue() {
      this.searchValue = null
      this.search()
    }
  }
}
</script>

<style lang="scss" scoped>
.search-box {
  display: flex;
  ::v-deep {
    .search-key-select {
      width: 120px;
      .el-input.is-focus .el-input__inner {
        border-color: #dcdfe6;
      }
      .el-input__inner {
        border-radius: 4px 0 0 4px;
        border-right: none;
        &:hover,
        &:focus {
          border-color: #dcdfe6;
        }
      }
    }
    .search-value-select {
      width: 220px;
      .el-input__inner {
        border-radius: 0;
      }
    }
    .special-compare-value {
      .number-range,
      .el-date-editor {
        width: 220px;
      }
    }
    .user-scope-selector-container {
      width: 220px;
      border-radius: 0;
      .value-wrapper {
        min-height: 30px;
      }
    }
    .search-input {
      &.el-input {
        width: 220px;
      }
      .el-input__inner {
        border-radius: 0;
        font-size: 14px;
      }
      .el-input-group__prepend {
        width: 100px;
        box-sizing: border-box;
        background-color: #fff;
        color: $color-font-first;
      }
    }
  }
  .icon-search-box {
    @include flex-center;
    background-color: #f5f7fa;
    color: #909399;
    border: 1px solid #dcdfe6;
    border-left: none;
    border-radius: 0 4px 4px 0;
    padding: 0 12px;
    font-size: 14px;
    cursor: pointer;
  }
}
</style>
